import React, { useState } from 'react'
import { useInterval } from '../hooks'
import { hhmmss } from '../utils'

const Counter = props => {
  const [counter, setCounter] = useState(0);

  useInterval(() => {
    setCounter(counter + 1);
  }, 1000);

  return <p>{ hhmmss(counter + props.seconds_since_start) }</p>;
}

export default Counter